/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RatingsSummary } from '@msdyn365-commerce/commerce-entities';
import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * This function gets the ratings summary
 */
async function getRatingsSummary(input:{}, ctx: Msdyn365.IActionContext): Promise<RatingsSummary> {
    return {};
}

export default Msdyn365.createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/get-ratings-summary',
    action: getRatingsSummary
});